import { render } from "./UploadForm.vue?vue&type=template&id=78270f1a"
import script from "./UploadForm.vue?vue&type=script&lang=js"
export * from "./UploadForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pip-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__